import React, { useState } from 'react';
// utils
import { getRoleName, validArray } from 'utils';
// Assets
import Icon from 'assets/Icon';
// Elements
import Button from 'elements/Button';
import { Modal, ModalContent, ModalFooter, ModalHeader } from 'elements/Modal';
// Styles
import styles from './style/siteCard.module.css';

interface OrganisationCardProps {
  handleEdit: Function,
  handleDelete: Function,
  isHomeOrganisation: boolean,
  roles: {
    roleName: string,
  }[],
  orgDescription: string,
}

function OrganisationCard({
  handleEdit,
  handleDelete,
  isHomeOrganisation,
  roles,
  orgDescription,
}:OrganisationCardProps) {
  const [modal, setModal] = useState(false);
  const roleList = roles.map(getRoleName);
  
  function renderRole(role:string) {
    return (
      <li key={role}>
        {role.split('_').join(' ').toLowerCase()}
      </li>
    );
  }

  function handleDeleteConfirm() {
    handleDelete();
    setModal(false)
  }

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <h3 className="display6">{orgDescription}</h3>
        <h6 className="subtitle2">Roles</h6>
        <ul className={styles.roles}>
          {validArray(roleList) ? (
            roleList.map(renderRole)
          ) : (
            <li>None selected</li>
          )}
        </ul>
      </div>
      <div className={styles.footer}>
        <Button
          btnStyle="primary"
          handler={() => handleEdit()}
        >
          Amend
        </Button>
        <Button
          btnType="icon"
          handler={() => setModal(true)}
          label="Delete"
        >
          <Icon icon="Bin" fill="warm-grey-700" size={32} />
        </Button>
      </div>
      <Modal active={modal}>
        <ModalHeader heading="Delete Organisation" />
        <ModalContent>
          <p>Are you sure you want to delete organisation?</p>
        </ModalContent>
        <ModalFooter>
          <Button handler={() => setModal(false)}>
            No
          </Button>
          <Button
            btnStyle="secondary"
            handler={() => handleDeleteConfirm()}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default OrganisationCard;
